import { useQuery } from "@apollo/client";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { Badge, IconButton } from "@mui/material";
import { useCanAccess, useTranslate } from "react-admin";
import { useNavigate } from "react-router-dom";

import { FINANCE_NOTIFICATIONS_ROUTE, ResourceName } from "../../constants/resources";
import { FinanceNotificationCountDocument, type FinanceNotificationCountQuery } from "../../generated/graphql";

// The sync runs every few hours; polling shows a change by a colleague.
export const FINANCE_NOTIFICATION_COUNT_POLL_MS = 30_000;

// The header's count of open Finance notifications, for the staff who handle them.
export const FinanceNotificationBadge = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { canAccess } = useCanAccess({ action: "list", resource: ResourceName.FinanceNotificationBadge });
  const allowed = canAccess === true;
  const { data } = useQuery<FinanceNotificationCountQuery>(FinanceNotificationCountDocument, {
    skip: !allowed,
    fetchPolicy: "cache-and-network",
    pollInterval: FINANCE_NOTIFICATION_COUNT_POLL_MS,
  });
  if (!allowed) return null;

  const count = data?.financeNotificationCount ?? 0;
  return (
    <IconButton
      data-testid="finance-notification-badge"
      aria-label={translate("financeNotifications.badge.label", { smart_count: count })}
      onClick={() => navigate(FINANCE_NOTIFICATIONS_ROUTE)}
      sx={{ minWidth: 44, minHeight: 44 }}
    >
      <Badge badgeContent={count} color="error" max={99}>
        <NotificationsOutlinedIcon />
      </Badge>
    </IconButton>
  );
};
